module.exports = __webpack_public_path__ + "img/Press_Release_KreditPro_X_eFishery.0d169cf8.jpeg";